import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { NumberFormatDecimal } from '../../utils'

const useStyles = makeStyles((theme) => ({
	dialog: {
		'& .MuiDialog-paper': {
			maxWidth: '920px',
			minWidth: '700px'
		}
	},
	formWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		margin: '24px 0px',
		'& .MuiTextField-root': {
			minWidth: '274px !important'
		},
		'& .MuiFilledInput-underline': {
			minWidth: '274px !important'
		}
	},
	fieldWrapper: {
		'&:nth-child(odd)': {
			marginRight: '25px'
		},
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '20px'
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	chip: {
		marginRight: 2
	},
	currencyAdornment: {
		marginLeft: '10px',
		marginTop: '7px !important'
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	datePicker: {
		'& .MuiInputLabel-filled': {
			transform: 'translate(48px, 20px) scale(1)'
		},
		'& .MuiInputLabel-shrink': {
			transform: 'translate(48px, 10px) scale(0.75)'
		},
		'&:nth-child(1)': {
			marginRight: '16px !important'
		}
	}
}))

const levels = ['full length', 'top-level', 'lower-level']
const floors = ['ground floor']

const KennelTypeDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [mapped_areas, setMappedAreas] = useState([])

	const { isShown, setIsShown, kennelType, updateType, save, areas, kennels, setDelete } = props

	const isDisabled = () => {
		if (
			!kennelType ||
			!kennelType.name ||
			!kennelType.width ||
			!kennelType.depth ||
			!kennelType.level ||
			!kennelType.floor ||
			!kennelType.hasOwnProperty('crate') ||
			kennelType.name.length > 25
		)
			return true
		return false
	}

	return (
		<Dialog
			open={isShown}
			width="md"
			onClose={() => setIsShown()}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}>
			<DialogTitle>{kennelType?._id ? 'Edit Kennel Type' : 'Add New Kennel Type'}</DialogTitle>
			<DialogContent>
				<div className={classes.formWrapper}>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<TextField
							label="Name"
							value={kennelType.name}
							error={kennelType.name?.length > 25}
							helperText={`${kennelType.name?.length || 0} / 25`}
							style={{ width: '48%', marginBottom: 16 }}
							required
							onChange={(e) => updateType('name', e.target.value)}
							variant="filled"
						/>
						<TextField
							label="Width"
							value={kennelType.width}
							type="number"
							style={{ width: '48%', marginBottom: 16 }}
							required
							onChange={(e) => {
								updateType('width', e.target.value)
							}}
							InputProps={{
								inputComponent: NumberFormatDecimal
							}}
							variant="filled"
						/>
					</div>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<TextField
							label="Depth"
							value={kennelType.depth}
							type="number"
							style={{ width: '48%', marginBottom: 16 }}
							required
							onChange={(e) => {
								updateType('depth', e.target.value)
							}}
							InputProps={{
								inputComponent: NumberFormatDecimal
							}}
							variant="filled"
						/>

						<TextField
							label="Square Feet"
							value={kennelType.sq_ft || '0'}
							disabled={true}
							style={{ width: '48%', marginBottom: 16, textTransform: 'capitalize' }}
							variant="filled"
						/>
					</div>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<TextField
							select
							label="Level"
							value={kennelType.level}
							style={{ width: '48%', marginBottom: 16, textTransform: 'capitalize' }}
							required
							onChange={(e) => updateType('level', e.target.value)}
							variant="filled">
							{levels.map((s) => (
								<MenuItem value={s} style={{ textTransform: 'capitalize' }}>
									{s}
								</MenuItem>
							))}
						</TextField>

						<TextField
							select
							label="Building Floor"
							value={kennelType.floor}
							style={{ width: '48%', marginBottom: 16, textTransform: 'capitalize' }}
							required
							onChange={(e) => updateType('floor', e.target.value)}
							variant="filled">
							{floors.map((s) => (
								<MenuItem value={s} style={{ textTransform: 'capitalize' }}>
									{s}
								</MenuItem>
							))}
						</TextField>
					</div>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<TextField
							select
							label="Crate"
							value={kennelType.crate}
							style={{ width: '48%', marginBottom: 16, textTransform: 'capitalize' }}
							onChange={(e) => updateType('crate', e.target.value)}
							variant="filled">
							{[
								{ label: 'yes', value: true },
								{ label: 'no', value: false }
							].map((s) => (
								<MenuItem value={s.value} style={{ textTransform: 'capitalize' }}>
									{s.label}
								</MenuItem>
							))}
						</TextField>
					</div>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" onClick={save} color="secondary" disabled={isDisabled()}>
					SAVE
				</Button>
				<Button variant="outlined" onClick={() => setIsShown()} color="secondary">
					CANCEL
				</Button>
				{kennelType?._id && (
					<Button
						variant="text"
						onClick={() => {
							setDelete('kennel type')
						}}
						style={{
							fontFamily: 'Nunito',
							color: '#D02C2C',
							fontSize: '14px',
							lineHeight: '19px',
							marginLeft: 'auto',
							textTransform: 'uppercase',
							fontWeight: '800'
						}}>
						Delete Kennel Type
					</Button>
				)}
			</DialogActions>
		</Dialog>
	)
}

export default KennelTypeDialog
